import createApiService from "../../http";
export const CREATE_FEEDBACK_API = '/feedback';

export const createFeedbackService =  createApiService({
    endpoint: CREATE_FEEDBACK_API,
    method: 'post'
});

